import { all } from 'redux-saga/effects';
import { watchUserOnBoarding } from './feature/userOnBoarding/sagas/userOnBoardingSaga';
import { drawerSaga } from './feature/drawer/sagas/drawerSaga';
import { homeSaga } from './feature/workflow/sagas/homeSaga';
import { reportSaga } from './feature/workflow/sagas/reportSaga';

export default function* rootSaga() {
  yield all([watchUserOnBoarding(), drawerSaga(), reportSaga(), homeSaga()]);
}
